import React from 'react';
import { Button, Tooltip, Text, Icon, Flexer } from '@ontruck/orc';
import styles from '../style.module.scss';

const t = {
  do_not_disturb: "Don't disturb",
  call_later: 'Call later',
  set_call_status: 'Set call status',
};

const CallStatus =
  (handleClick) =>
  ({ rowData }) => {
    const { carrier } = rowData;
    const { id } = carrier;

    if (!carrier.callstatus_set) {
      return null;
    }
    if (carrier.callstatus_set.length) {
      const callStatus = carrier.callstatus_set[0];
      return (
        <p>
          <Tooltip component={callStatus.comment} skin="dark">
            {callStatus.status === 'BLOCK' && (
              <div>
                <Flexer.Parent>
                  <Flexer.Child mRight="XS">
                    {callStatus.comment && (
                      <Icon glyph="info" color="blueButterfly" size="1.5rem" />
                    )}
                  </Flexer.Child>
                  <Flexer.Child>
                    <Text color="grey500" weight="bold">
                      {t.do_not_disturb}
                    </Text>
                  </Flexer.Child>
                </Flexer.Parent>
              </div>
            )}
            {callStatus.status === 'LATER' && (
              <div>
                <Flexer.Parent>
                  <Flexer.Child mRight="XS">
                    {callStatus.comment && (
                      <Icon glyph="info" color="blueButterfly" size="1.5rem" />
                    )}
                  </Flexer.Child>
                  <Flexer.Child>
                    <Text color="orangePeachText" weight="bold">
                      {t.call_later}
                    </Text>
                  </Flexer.Child>
                </Flexer.Parent>
              </div>
            )}
          </Tooltip>
        </p>
      );
    }
    return (
      <div className={styles.onlyHover}>
        <div>
          <Button
            noWrap
            ghost
            text={t.set_call_status}
            onClick={(e) => {
              e.stopPropagation();
              handleClick(id);
            }}
            disabled={false}
            dataE2E={'detail__launch'}
          />
        </div>
      </div>
    );
  };
export default CallStatus;
